import { render, staticRenderFns } from "./DashboardDisplay.vue?vue&type=template&id=06c9a164&scoped=true"
import script from "./DashboardDisplay.vue?vue&type=script&lang=js"
export * from "./DashboardDisplay.vue?vue&type=script&lang=js"
import style0 from "./DashboardDisplay.vue?vue&type=style&index=0&id=06c9a164&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c9a164",
  null
  
)

export default component.exports